import React from 'react'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    padding: 16,
  }
}));

export default function  ContentArea({ children }) {
  const classes = useStyles()
  return (
    <div className={ classes.root }>
      { children }
    </div>
  )
}
